// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1c4hz","inputWrap":"styles_inputWrap__3jAz-","input":"styles_input__18O-e"};